import { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import Row from 'components/UIKit/Flex/Row';
import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import { DataCategoryDownloadContainer } from 'containers/DownloadContainers';
import { Spinner } from 'components/UIKit/Spinner';
import { DownloadIcon } from 'components/icons';
import { spinnable } from 'components/UIKit/decorators';

const modalStyles = {
  overlay: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    bottom: 'auto',
    left: 'auto',
    position: 'relative',
    right: 'auto',
    top: 'auto',
    width: '28rem',
  },
};

const styles = {
  cancelButton: {
    position: 'absolute',
    top: '1.5rem',
    right: '1.5rem',
    zIndex: 20,
    color: 'rgb(62, 62, 62)',
    textDecoration: 'none',
    fontSize: '1em',
    fontWeight: 'bold',
    cursor: 'pointer',
  },
  buttonText: {
    height: '4.8rem',
    lineHeight: '4.8rem',
    borderBottom: '3px solid #e5e5e5',
    paddingLeft: '10px',
    backgroundColor: 'white',
  },
};

class DataDownloadModalButton extends Component {
  static propTypes = {
    params: PropTypes.shape({
      program: PropTypes.string,
      project: PropTypes.string,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
    }),
    style: PropTypes.object,
    setIsSpinning: PropTypes.func.isRequired,
    isSpinning: PropTypes.boolean,
  };

  // $FlowIgnore
  state: Object = { modalIsOpen: false };

  // $FlowIgnore
  openModal: Function = () => {
    this.setState({ modalIsOpen: true });
  };

  // $FlowIgnore
  closeModal: Function = () => {
    this.setState({ modalIsOpen: false });
  };

  render(): React.Element {
    const { modalIsOpen } = this.state;
    const { style, isSpinning, setIsSpinning } = this.props;

    return (
      <Row data-testid="button-project-data">
        <ButtonTemplate
          style={style}
          disabled={isSpinning}
          onClick={this.openModal}
          PrefixComponent={
            isSpinning
              ? <Spinner style={{ width: '14px', height: '14px', margin: '0 0.25rem' }} />
              : <DownloadIcon style={{ margin: '0 .25rem' }} />
          }
          >
          Project Data
        </ButtonTemplate>
        <Modal
          style={modalStyles}
          closeTimeoutMS={150}
          isOpen={modalIsOpen}
          onRequestClose={() => {}}
          >
          <a style={styles.cancelButton} onClick={this.closeModal}>
            CANCEL &#10005;
          </a>
          <div style={styles.buttonText}>Download Data</div>
          <DataCategoryDownloadContainer
            closeModal={this.closeModal}
            setIsSpinning={setIsSpinning}
            />
        </Modal>
      </Row>
    );
  }
}

export default spinnable(DataDownloadModalButton);
